<template>
	<Layout navbarTitle="" :mainFixed="false" navBackLink="/">
		<div class="tab-content" v-if="tab == 'DASHBOARD'">
			<div class="event-head" v-if="event">
				<div class="image" v-if="event.image" :style="`background-image:url(${event.image.url})`"></div>
				<div class="data">
					<div class="date">
						<span class="day">{{ event.startAt | moment("DD") }}</span>
						<span class="month">{{ event.startAt | moment("MMM") }}</span>
					</div>
					<div class="flex-grow-1">
						<div class="ml-1">
							<h2>{{ event.name }}</h2>
						</div>
						<div class="data-set" v-if="event.location">
							<i class="icon icon-map-marker"></i>
							<div class="info">
								<h2>{{ event.location.name }}</h2>
								<p>
									{{ event.location.address }},
									<span v-if="event.location.locality">{{ event.location.locality.name }}, </span>
									<span v-if="event.location.locality">{{
										event.location.locality.region.name
									}}</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="bottom-navbar">
			<!-- <div class="btn" v-ripple @click="tab = 'DASHBOARD'">
				<i class="icon icon-chart-bar"></i>
				<span>DASHBOARD</span>
			</div> -->
			<div class="btn" v-ripple @click="$refs.clientsEnabled.open()">
				<i class="icon icon-users-outline"></i>
				<span>HABILITADOS</span>
			</div>
			<div class="btn btn-main" v-ripple @click="checkInOpen">
				<i class="icon icon-qr-scanner"></i>
				<span>CHECK IN</span>
			</div>
			<div class="btn" v-ripple @click="$refs.eventAccess.open()">
				<i class="icon icon-users-outline"></i>
				<span>ASISTENTES</span>
			</div>
		</div>

		<div v-if="event">
			<EventClientsEnabled :eventId="event.id" ref="clientsEnabled" />
			<EventAccess :eventId="event.id" ref="eventAccess" />
			<EventCheckIn ref="eventCheckIn" :event="event" />
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/layout/Layout"
import Loader from "@/components/layout/Loader"
import EventClientsEnabled from "./EventClientsEnabled"
import EventAccess from "./EventAccess"

import EventCheckIn from "./EventCheckIn"

export default {
	name: "EventDetail",
	components: {
		Layout,
		Loader,
		EventClientsEnabled,
		EventCheckIn,
		EventAccess
	},
	data() {
		return {
			loading: false,
			tab: "DASHBOARD",
			event: null
		}
	},
	beforeMount() {
		this.load()
	},

	methods: {
		checkInOpen() {
			this.$refs.eventCheckIn.open()
		},

		load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								code
								name
								image {
									id
									url
								}
								startAt
								location {
									id
									name
									locality {
										name
										region {
											name
										}
									}
									address
									latlng {
										lat
										lng
									}
								}
								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						id: this.$route.params.id
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.event = data.event
				})
				.catch((err) => {
					// this.$toast.error("Error al cargar la inspección")
				})
		}
	}
}
</script>

<style scoped lang="scss">
.tab-content {
	padding: 16px 16px 46px 16px;
	transition: all 0.3s ease;
}

.event-head {
	width: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;

	.image {
		width: 100%;
		padding-bottom: 70%;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		border-radius: 8px;
	}

	.data {
		padding: 18px 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		margin: -17px 16px 0px;
		padding: 10px 10px;
		background-color: #fff;
		border-radius: 8px;

		.date {
			width: 50px;
			flex-shrink: 0;
			display: flex;
			flex-direction: column;
			align-items: center;

			.day {
				font-size: 24px;
				line-height: 18px;
				font-weight: bold;
				color: #000;
			}
			.month {
				font-size: 14px;
				color: #000;
				text-transform: uppercase;
				line-height: 16px;
			}
		}

		h2 {
			font-size: 1.16rem;
			color: #000;
			font-weight: 500;
		}
		.data-set {
			display: flex;
			align-items: flex-start;
			justify-self: start;
			cursor: pointer;

			.icon {
				width: 18px;
				flex-shrink: 0;
				font-size: 1.3rem;
				color: #bbb;
				margin-top: 3px;
				margin-right: 10px;
			}
			.info {
				flex-grow: 1;

				h2 {
					font-size: 1em;
				}
				p {
					font-size: 0.95em;
					color: #666;
					line-height: 0.8rem;
					margin: 0px;
				}
			}
		}
	}
}

.bottom-navbar {
	background-color: #2e2e2e;
	position: fixed;
	bottom: 0px;
	left: 0px;
	right: 0px;
	display: flex;
	align-items: center;
	justify-content: space-around;

	.btn {
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

		.icon {
			font-size: 1.3rem;
			width: 24px;
			height: 24px;
		}
		span {
			font-size: 0.6rem;
		}
	}
	.btn-main {
		border-radius: 36px;
		background-color: #f5c514;
		width: 72px;
		height: 72px;
		font-weight: 600;
		margin-top: -24px;
		position: relative;

		.icon {
			font-size: 2.2rem;
			width: 36px;
			height: 36px;
		}
	}
}

.list {
	.item {
		padding: 8px 12px;
		display: flex;
		align-items: center;

		&:hover {
			background-color: #2e2e2e;
		}

		.circle {
			width: 42px;
			height: 42px;
			border-radius: 24px;
			margin-right: 8px;
			display: flex;
			align-items: center;
			justify-content: center;

			.icon {
				width: 22px;
				height: 22px;
				font-size: 20px;
			}
		}

		h3 {
			font-size: 1rem;
			color: #fff;
			font-weight: 500;
		}
		p {
			font-size: 0.8rem;
			color: #fff;
			line-height: 0.8rem;
			margin: 0px;
		}
	}
}
</style>
